import { useState, type FormEvent } from "react";

export default function NewsletterForm() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setStatus("error");
      setMessage("Please enter a valid email.");
      return;
    }
    setStatus("loading");
    try {
      const body = new URLSearchParams();
      body.append("email", email);
      const res = await fetch("https://readdy.ai/api/form/d82msncagmafep7uqk6g", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      if (!res.ok) throw new Error("Request failed");
      setStatus("success");
      setMessage("Welcome to the field. Check your inbox.");
      setEmail("");
    } catch {
      setStatus("error");
      setMessage("Something went wrong. Please try again.");
    }
  };

  return (
    <form
      id="verdant-newsletter"
      data-readdy-form
      onSubmit={onSubmit}
      className="w-full"
    >
      <div className="flex items-center gap-2 border border-bone/30 rounded-full p-1.5 pl-5 bg-bone/5 focus-within:border-bone/60 transition-colors">
        <i className="ri-mail-line text-bone/60 text-base w-5 h-5 flex items-center justify-center"></i>
        <input
          type="email"
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="your@email.com"
          className="flex-1 bg-transparent outline-none text-sm text-bone placeholder:text-bone/40 py-2"
          required
        />
        <button
          type="submit"
          disabled={status === "loading"}
          className="bg-bone text-forest text-xs font-medium tracking-wide uppercase px-5 py-2.5 rounded-full hover:bg-clay transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60"
        >
          {status === "loading" ? "…" : "Subscribe"}
        </button>
      </div>
      {status !== "idle" && status !== "loading" && (
        <p
          className={`mt-3 text-xs ${
            status === "success" ? "text-clay" : "text-rust"
          }`}
        >
          {message}
        </p>
      )}
    </form>
  );
}